import styled from 'styled-components';

export const PageContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;

  @media (max-width: 768px) {
    padding: 20px 16px;
  }
`;

export const BackLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #fa4616;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  margin-bottom: 24px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const TermsContent = styled.div`
  color: #4a5568;
  font-size: 14px;
  line-height: 1.8;

  h1 {
    color: #1a202c;
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }

  h3 {
    color: #1a202c;
    font-size: 16px;
    font-weight: 600;
    margin: 24px 0 12px 0;

    &.exhibit-title {
      text-align: center;
      font-size: 18px;
      margin-top: 32px;
    }
  }

  h4 {
    color: #2d3748;
    font-size: 14px;
    font-weight: 600;
    margin: 16px 0 8px 0;
  }

  p {
    margin: 0 0 16px 0;

    &.indent {
      margin-left: 18px;
    }

    &.indent-more {
      margin-left: 36px;
    }
  }

  strong {
    color: #1a202c;
    font-weight: 600;
  }

  .last-updated {
    font-size: 13px;
    color: #718096;
    margin-bottom: 24px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    font-size: 13px;

    th,
    td {
      border: 1px solid #e2e8f0;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background: #f7fafc;
      color: #1a202c;
      font-weight: 600;
    }

    td {
      color: #4a5568;
    }

    @media (max-width: 600px) {
      thead {
        display: none;
      }

      tbody tr {
        display: block;
        margin-bottom: 6px;
        background: #f7fafc;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        padding: 4px 0;
      }

      td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: none;
        padding: 3px 10px;
        text-align: right;

        &::before {
          content: attr(data-label);
          color: #718096;
          font-weight: 500;
          text-align: left;
          margin-right: 8px;
        }

        &:first-child {
          display: block;
          color: #1a202c;
          font-weight: 600;
          padding-bottom: 2px;
          text-align: left;

          &::before {
            display: none;
          }
        }
      }
    }
  }

  ul {
    margin: 0 0 16px 0;
    padding-left: 24px;

    li {
      margin-bottom: 8px;
    }
  }
`;
